import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const procedureData = {
  cardiology: {
    title: "Coronary Artery Bypass Graft (CABG / Heart Bypass)",
    usCost: 120000,
    ukCost: 70000,
    indiaCost: 6500,
    savings: "92%",
    duration: "14-21 Days",
    details: "Includes pre-operative cardiac evaluations, premium drug-eluting stents or bypass graft lines, ICU stay, and post-procedural diagnostic monitoring loops."
  },
  orthopedics: {
    title: "Robotic Total Knee / Hip Joint Replacement",
    usCost: 45000,
    ukCost: 28000,
    indiaCost: 5200,
    savings: "88%",
    duration: "10-14 Days",
    details: "Covers high-flexion FDA-approved implants, modern computer-navigated robotic assistant tracks, operational surgical theater use, and localized physical rehab."
  },
  oncology: {
    title: "Bone Marrow Transplant (BMT) / Advanced Cancer Care",
    usCost: 250000,
    ukCost: 140000,
    indiaCost: 22000,
    savings: "91%",
    duration: "30-45 Days",
    details: "Includes specialized high-sterility isolation suite parameters, chemotherapy/radiation pre-conditioning setups, stem cell harvests, and chronological cellular monitoring."
  }
};

function CompareCosts() {
  const [selectedSpecialty, setSelectedSpecialty] = useState('cardiology');
  const current = procedureData[selectedSpecialty];

  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 600px) {
          .filter-btn { width: 100% !important; text-align: center; }
          .cta-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* RICH SEO META HEADERS */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Medical Treatment Cost Calculator: Compare Private Healthcare Packages In India
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          Cross-border medical travel planning requires absolute clarity regarding financial benchmarks. This interactive diagnostic cost comparison matrix calculates pricing averages across elite, internationally accredited private corporate hospital networks in major metropolitan clusters like New Delhi, Gurgaon, and Noida. 
        </p>
      </header>

      {/* SPECIALTY FILTER TOGGLE SELECTION - RESPONSIVE */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '30px' }}>
        <button className="filter-btn" onClick={() => setSelectedSpecialty('cardiology')} style={{ padding: '12px 20px', fontSize: '0.95rem', fontWeight: 'bold', borderRadius: '4px', border: 'none', cursor: 'pointer', minHeight: '44px', background: selectedSpecialty === 'cardiology' ? '#0b3c5d' : '#f4f8fb', color: selectedSpecialty === 'cardiology' ? '#fff' : '#0b3c5d' }}>
          ❤️ Cardiac Surgery Pricing
        </button>
        <button className="filter-btn" onClick={() => setSelectedSpecialty('orthopedics')} style={{ padding: '12px 20px', fontSize: '0.95rem', fontWeight: 'bold', borderRadius: '4px', border: 'none', cursor: 'pointer', minHeight: '44px', background: selectedSpecialty === 'orthopedics' ? '#0b3c5d' : '#f4f8fb', color: selectedSpecialty === 'orthopedics' ? '#fff' : '#0b3c5d' }}>
          🦴 Joint Replacement Pricing
        </button>
        <button className="filter-btn" onClick={() => setSelectedSpecialty('oncology')} style={{ padding: '12px 20px', fontSize: '0.95rem', fontWeight: 'bold', borderRadius: '4px', border: 'none', cursor: 'pointer', minHeight: '44px', background: selectedSpecialty === 'oncology' ? '#0b3c5d' : '#f4f8fb', color: selectedSpecialty === 'oncology' ? '#fff' : '#0b3c5d' }}>
          🎗️ Oncology & BMT Pricing
        </button>
      </div>

      {/* DYNAMIC CALCULATOR OUTPUT CARDS - SAFELY BALANCED */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '25px', marginBottom: '35px' }}>
        
        {/* PRIVATE SAVINGS CARD */}
        <div style={{ padding: '25px', background: '#f4f8fb', borderRadius: '6px', border: '1px solid #e0e6ed', textAlign: 'center', boxSizing: 'border-box' }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.1rem' }}>Average Package Estimates (India)</h4>
          <div style={{ fontSize: 'clamp(2rem, 8vw, 2.5rem)', fontWeight: 'bold', color: '#28a745', margin: '15px 0' }}>
            ${current.indiaCost.toLocaleString()}
          </div>
          <span style={{ background: '#28a745', color: '#fff', padding: '6px 12px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 'bold', display: 'inline-block' }}>
            Saves up to {current.savings} vs Western Markets
          </span>
        </div>

        {/* COMPARATIVE WORLD MATRIX CARD */}
        <div style={{ padding: '25px', border: '1px solid #eee', borderRadius: '6px', display: 'flex', flexDirection: 'column', gap: '14px', boxSizing: 'border-box' }}>
          <h4 style={{ margin: '0 0 5px 0', color: '#333', fontSize: '1.1rem' }}>Global Cost Benchmarking</h4>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f5f5f5', paddingBottom: '8px', fontSize: '0.95rem', flexWrap: 'wrap', gap: '4px' }}>
            <span>United States average price:</span>
            <strong style={{ color: '#d9534f' }}>${current.usCost.toLocaleString()}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f5f5f5', paddingBottom: '8px', fontSize: '0.95rem', flexWrap: 'wrap', gap: '4px' }}>
            <span>United Kingdom average price:</span>
            <strong style={{ color: '#f0ad4e' }}>${current.ukCost.toLocaleString()}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontSize: '0.95rem', flexWrap: 'wrap', gap: '4px' }}>
            <span>Recommended Medical Stay Window:</span>
            <strong>{current.duration}</strong>
          </div>
        </div>

      </div>

      {/* DETAILED CONTENT AREA */}
      <section style={{ marginBottom: '35px', lineHeight: '1.7', color: '#444' }}>
        <h3 style={{ color: '#0b3c5d', fontSize: 'clamp(1.2rem, 5vw, 1.4rem)', borderBottom: '2px solid #ff9f1c', paddingBottom: '8px', marginBottom: '15px' }}>
          Procedural Logistics Scope: {current.title}
        </h3>
        <p style={{ fontSize: '0.95rem', marginBottom: '15px' }}>{current.details}</p>
        <p style={{ fontSize: '0.95rem', margin: 0 }}>
          International patient workflows seeking therapeutic configurations in private networks utilize these open cost sheets as initial references. To customize your timeline metrics, match medical fields, and organize pre-travel data structures, navigate over to our comprehensive lead mapping portal.
        </p>
        <div style={{ marginTop: '20px' }}>
          <Link to="/submit-query" className="cta-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 25px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', display: 'inline-block' }}>
            Request Independent Cost Verification Check →
          </Link>
        </div>
      </section>

      {/* INDEPENDENT VENUE LIABILITY PLATFORM DISCLAIMER */}
      <section style={{ background: '#fafafa', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
        <h4 style={{ color: '#333', marginTop: '0', marginBottom: '10px' }}>Regulatory Pricing Matrix Disclaimer</h4>
        <p style={{ margin: '0', fontSize: '0.85rem', color: '#666', lineHeight: '1.6', textAlign: 'left' }}>
          <strong>Medical Trip World</strong> operates strictly as an independent informational directory and statistical compilation manual. We do not maintain active commercial partnerships, exclusive contracts, or operational Memorandums of Understanding (MOUs) with any medical facility brand or private clinic chain. All displayed values, pricing parameters, and package estimates are synthesized from open public records and baseline industry research for educational mapping purposes only. Absolute financial schedules are subject to clinical variations and are executed solely via direct private contract agreements between the traveling patient and their self-selected healthcare professional.
        </p>
      </section>

    </article>
  );
}

export default CompareCosts;